import MuiTypography, {
    type TypographyProps as MuiTypographyProps,
} from '@mui/material/Typography';
import { type ElementType, forwardRef } from 'react';
import type { Property } from 'csstype';

const gradientStyles = (gradient: string) => ({
    background: gradient,
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
});

interface OwnProps {
    textTransform?: Property.TextTransform;
    variant?: MuiTypographyProps['variant'];
    component?: ElementType;
    htmlColor?: string;
    gradient?: string;
}

export type TypographyProps = OwnProps & Omit<MuiTypographyProps, 'variant'>;

export const Typography = forwardRef<HTMLElement, TypographyProps>(
    ({ textTransform, variant = 'body2', htmlColor, gradient, sx, ...props }, ref) => {
        return (
            <MuiTypography
                sx={[
                    {
                        textTransform,
                        color: htmlColor ?? 'inherit',
                        ...(gradient && gradientStyles(gradient)),
                    },
                    ...(Array.isArray(sx) ? sx : [sx]),
                ]}
                variant={variant}
                display="block"
                ref={ref}
                {...props}
            />
        );
    },
);
Typography.displayName = 'Typography';
